import {HubriseObjectRestrictionContract, HubriseRestrictionEnforcerContract} from 'common/api/hubrise/service/HubriseRestrictionEnforcerContract';
import {HubriseMenuVariantContract} from 'common/api/hubrise/model/menu/HubriseMenuVariantContract';
import {DateTime} from 'luxon';

export class HubriseRestrictionEnforcer implements HubriseRestrictionEnforcerContract {
    public filter<ObjectContract>(list: HubriseObjectRestrictionContract[], date: string, variant?: HubriseMenuVariantContract): ObjectContract[] {
        const datetime: DateTime = DateTime.fromISO(date, {setZone: true});
        const currentTime: string = datetime.toISOTime({suppressSeconds: true, suppressMilliseconds: true, includeOffset: false});
        const currentDate: string = datetime.toISODate();

        return list.filter((obj) => {
            if (typeof obj.restrictions !== 'object') {
                return true;
            }

            if (obj.restrictions.enabled === false) {
                return false;
            }

            if (typeof obj.restrictions.dow === 'string' && !obj.restrictions.dow.includes(String(datetime.weekday))) {
                return false;
            }

            if (typeof obj.restrictions.start_time === 'string' && currentTime < obj.restrictions.start_time) {
                return false;
            }
            if (typeof obj.restrictions.end_time === 'string' && currentTime > obj.restrictions.end_time) {
                return false;
            }

            if (typeof obj.restrictions.start_date === 'string' && currentDate < obj.restrictions.start_date) {
                return false;
            }
            if (typeof obj.restrictions.end_date === 'string' && currentDate > obj.restrictions.end_date) {
                return false;
            }

            if (variant !== undefined && Array.isArray(obj.restrictions.variant_refs) && variant.ref !== '0' && !obj.restrictions.variant_refs.includes(variant.ref)) {
                return false;
            }

            return true;
        }) as ObjectContract[];
    }
}
